import axiosInstance from "../config/axiosInterceptor";

export async function getRegion() {
  return await axiosInstance.get("/api/Region");
}

export async function getRegionById(id) {
  return await axiosInstance.get(`/api/Region/${id}`);
}

export async function postRegion({ code, name, description, admin_idAdmin, parentRegion }) {
  const requestData = {
    idRegion: 0,
    code,
    name,
    description,
    admin_idAdmin,
    parentRegion,
    isdeleted: 0
  };

  return await axiosInstance.post("/api/Region", requestData);
}

export async function putRegion({ idRegion, code, name, description, admin_idAdmin, parentRegion }) {
  const requestData = {
    idRegion,
    code,
    name,
    description,
    admin_idAdmin,
    parentRegion,
    isdeleted: 0
  };

  return await axiosInstance.put("/api/Region", requestData);
}

export async function deleteRegion(idRegion) {
  return await axiosInstance.delete(`/api/Region/${idRegion}`);
}